import React from 'react';
import Footer from '../../components/Common/Footer/Footer';
import Header from '../../components/Common/Header/Header';
import SubHeader from '../../components/Common/SubHeader/SubHeader';
import TrackOrderBanner from '../../components/Trackorder/TrackOrderBanner/TrackOrderBanner';
import TrackOrderDetails from '../../components/Trackorder/TrackOrderDetails/TrackOrderDetails';

const TrackOrder = () => {
    return (
        <div>
            <SubHeader/>
            <Header/>
            <TrackOrderBanner/>
            <TrackOrderDetails/>
            <Footer/>
        </div>
    );
};

export default TrackOrder;